/**
 * The required-field asterisk, appended to a field's label.
 *
 * Visual only (`aria-hidden`): screen readers get "required" from
 * `aria-required` on the control itself, which every field component sets
 * alongside this mark, so the star is never read out as "star".
 *
 * Auth forms (login, signup, recovery) deliberately do not use it: every
 * field there is required, and marking all of them says nothing. Everywhere
 * else a form mixes required and optional fields, and the mark is what tells
 * them apart before the user submits.
 */
export default function RequiredMark() {
  return (
    <span className="yp-req" aria-hidden="true">
      *
    </span>
  );
}

/** A label with the mark appended when `required` — for adapters that hand
    their label to an MUI control rather than rendering it themselves. */
export function requiredLabel(label: React.ReactNode, required?: boolean) {
  if (!required || !label) return label;
  return (
    <>
      {label}
      <RequiredMark />
    </>
  );
}
